import dayjs from "dayjs";
import {
  Box,
  Card,
  Grid,
  Button,
  Checkbox,
  IconButton,
  Typography,
  FormControlLabel,
  Dialog,
  Divider,
  Tooltip,
  CardContent,
  DialogTitle,
  OutlinedInput,
  DialogContent,
  DialogActions,
  CardHeader,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect, useMemo } from "react";
import {
  Add,
  Close,
  Edit,
  Home,
  Info,
  Visibility,
  WarningRounded,
} from "@material-ui/icons";

import theme from "../../../../theme";
import KPTable from "../../../../components/KPTComponents/KPTable";
import Loading from "../../../../components/CustomComponents/Loading";
import KPTextform from "../../../../components/KPTComponents/KPTextform";
import InputActives from "../../ActivesField/InputActives";
import PreviewModal from "../../../../components/CustomComponents/PreviewModal";
import ThanhTichAlert from "../../../AppLayout/ThanhTichAlert/ThanhTichAlert";
import ThanhTichInsert from "../../../KVC/ThanhTichInsert/ThanhTichInsert";

import { photoRender } from "../../../../utils/photoRender";
import { useScreenSize } from "../../../../hooks/useScreenSize";
import { jumpToReleventDiv } from "../../../../components/KPTComponents/utils";
import { columnRender, capitalizeFirstLetter } from "../../../../utils";
import { fileActions, userActions, formActions } from "../../../../actions";
import {
  ROUTER,
  FORM_CONSTANTS,
  ACHIEVEMENT_TYPE,
  KEYS,
  SECONDARY_COLOR,
  CATEGORY,
  APP_SCENE,
} from "../../../../constants";
import ConfirmButton from "../../../../components/GTNS/DangKyHoSo/ConfirmButton";
import exportGtnsProfile from "../../../../utils/gtns.exportProfile";
import {
  GTNS2026_LINKS,
  GTNS2026_PRIORITY_FIELDS,
} from "../../../../constants/gtns2026.config";

export default function DangKiHoSo() {
  const dispatch = useDispatch();
  const isMobileMode = useScreenSize();

  const { POLITICAL_UNION_OPTIONS } = FORM_CONSTANTS;

  const [files, setFiles] = useState({});
  const [dialog, setDialog] = useState(null);
  const [values, setValues] = useState(null);
  const [emptyKey, setEmptyKey] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);
  const [acceptRules, setAcceptRules] = useState(false);
  const [warningOpen, setWarningOpen] = useState(false);
  const [uploadingFiles, setUploadingFiles] = useState(false);
  const [showCSKH, setShowCSKH] = useState(true);

  const [reward, setReward] = useState([]);
  const [socialActivity, setSocialActivity] = useState([]);
  const [majorAchievement, setMajorAchievement] = useState([]);
  // NSKH 2026: E. ƯU TIÊN (dân tộc thiểu số / khuyết tật) -> lưu JSON field `priority`
  const [priority, setPriority] = useState({});

  const profile = useSelector((state) => state.profileReducer.profile);
  const seasonList = useSelector((state) => state.seasonReducer.seasonList);
  const application = useSelector(
    (state) => state.formReducer.applicationList?.[0] || null
  );
  const openSeasonId = useSelector((state) => state.seasonReducer.openSeasonId);

  const loading = useSelector(
    (state) =>
      state.userReducer.loading ||
      state.formReducer.loading ||
      state.profileReducer.loading ||
      uploadingFiles
  );

  const rewards = useSelector((state) =>
    state.rewardReducer.personalRewardList?.map((e) => ({
      ...e,
      decisionDay: dayjs(e?.decisionDay).format("DD/MM/YYYY"),
    }))
  );

  // ---------------- ARCHIVEMENTS ---------------- //
  const achievementData = useSelector((state) => ({
    [ACHIEVEMENT_TYPE.SOLUTION]:
      state.solutionReducer.personalSolutionList.filter((e) =>
        ["sc", "scqg", "gp"].find((type) => type === e.type)
      ),
    [ACHIEVEMENT_TYPE.SOLUTION + CATEGORY.GTNS]:
      state.solutionReducer.personalSolutionList.filter((e) =>
        ["ptns-sc", "ptns-scqg", "ptns-gp"].find((type) => type === e.type)
      ),

    [ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT]:
      state.reportsReducer.personalReportList,

    [ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH]:
      state.researchReducer.personalResearchList,
    [ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.DOMESTIC]:
      state.researchReducer.personalResearchList.filter(
        (e) => e.filterType === KEYS.DOMESTIC
      ),
    [ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.INTERNATIONAL]:
      state.researchReducer.personalResearchList.filter(
        (e) => e.filterType === KEYS.INTERNATIONAL
      ),

    [ACHIEVEMENT_TYPE.REWARD]: rewards,
    [ACHIEVEMENT_TYPE.REWARD + KEYS.HTQT]: rewards.filter((e) =>
      ["g1", "g2", "g3-1"].find((type) => type === e.type)
    ),
    [ACHIEVEMENT_TYPE.REWARD + KEYS.HTQG]: rewards.filter((e) =>
      ["g3-2", "g4", "g5"].find((type) => type === e.type)
    ),
    [ACHIEVEMENT_TYPE.REWARD + KEYS.HTCS]: rewards.filter((e) =>
      ["nstb-g1", "nstb-g2", "nstb-g3-1"].find((type) => type === e.type)
    ),
    [ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHCB]: rewards.filter((e) =>
      ["nstb-n1", "nstb-n2", "nstb-n3", "nstb-n4"].find(
        (type) => type === e.type
      )
    ),
    [ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHCT]: rewards.filter((e) =>
      ["nstb-n5", "nstb-n6", "nstb-n7"].find((type) => type === e.type)
    ),
    // NSKH 2026: đề tài/dự án NCKH nghiệm thu xếp loại đạt
    [ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHDACB]: rewards.filter(
      (e) => e.type === "nstb-da-cb"
    ),
    [ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHDACT]: rewards.filter(
      (e) => e.type === "nstb-da-ct"
    ),
    // NSKH 2026: gộp 6.1 + 6.2 thành 1 mục chung
    [ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHDA]: rewards.filter((e) =>
      ["nstb-da-cb", "nstb-da-ct"].includes(e.type)
    ),
  }));

  const handleFileChange = (e, name) => setFiles({ ...files, [name]: e });

  const renderUploadFile = (title, value) => {
    const url = values?.[`upload${value[0].toUpperCase() + value.slice(1)}`];
    return (
      <>
        <Typography className="kpt-textfield-label">
          {title}
          <span style={{ color: theme.palette.secondary.main }}>*</span>:
        </Typography>
        {url ? (
          <OutlinedInput
            fullWidth
            size="small"
            value={url.slice(url.indexOf(".") + 1)}
            variant="outlined"
            style={{
              paddingRight: "0",
              backgroundColor: "white",
              height: "35px",
            }}
            endAdornment={
              <Box
                display="flex"
                justifyContent="space-around"
                alignItems="center"
                // style={{ padding: '0 12px' }}
              >
                <Divider orientation="vertical" style={{ height: 35 }} />
                <IconButton
                  edge="center"
                  color="secondary"
                  title="Chi tiết minh chứng"
                  onClick={() => setPreviewFile(url)}
                >
                  <Visibility />
                </IconButton>
                <Divider orientation="vertical" style={{ height: 35 }} />
                <IconButton
                  edge="center"
                  color="primary"
                  title="Chỉnh sửa minh chứng"
                  onClick={() => {
                    setValues({
                      ...values,
                      [`upload${value[0].toUpperCase() + value.slice(1)}`]:
                        null,
                    });
                  }}
                >
                  <Edit />
                </IconButton>
              </Box>
            }
          />
        ) : (
          <>
            <Card style={{ borderColor: "#b3b9c3", padding: "5.5px 8px" }}>
              <input
                type="file"
                style={{ width: "100%" }}
                onChange={(e) => {
                  if (e.target.files[0].size > 10485760) {
                    e.target.value = null;
                    dispatch(
                      userActions.notification({
                        message: "Dung lượng vượt quá hơn 10MB",
                        type: "error",
                      })
                    );
                  } else {
                    handleFileChange(e.target.files[0], value);
                  }
                }}
              />
            </Card>
            {emptyKey === `upload${value[0].toUpperCase() + value.slice(1)}` &&
              !files?.[value] && (
                <Typography style={{ fontSize: 12, color: "#f9625b" }}>
                  Không được để trống
                </Typography>
              )}
          </>
        )}
      </>
    );
  };

  const textForm = {
    base: [
      {
        key: "name",
        width: isMobileMode ? 12 : 8,
        label: "Họ và tên",
        value: profile?.name,
        required: true,
        disabled: true,
      },
      {
        key: "birth",
        width: isMobileMode ? 12 : 4,
        label: "Ngày sinh",
        value: dayjs(profile?.birth).format("DD/MM/YYYY"),
        type: "date",
        disabled: true,
        required: true,
      },
      {
        key: "ethnic",
        width: isMobileMode ? 12 : 4,
        label: "Dân tộc",
        value: profile?.ethnic,
        disabled: true,
        required: true,
      },
      {
        key: "phone",
        width: isMobileMode ? 12 : 8,
        label: "Số điện thoại",
        value: profile?.phone,
        required: true,
        disabled: true,
      },
      {
        key: "email",
        width: 12,
        label: "Email",
        value: profile?.email,
        required: true,
        disabled: true,
      },
      {
        key: "website",
        width: 12,
        height: 1,
        label: "Website/Facebook",
        required: true,
        value: profile?.website,
        disabled: true,
      },
    ],
    partI: [
      {
        key: "nominator",
        width: 12,
        height: 1,
        label: "Đơn vị đề cử",
        required: true,
        value: values?.nominator,
      },
      {
        key: "nominatorPhone",
        width: isMobileMode ? 12 : 5,
        label: "Điện thoại liên hệ đơn vị đề cử",
        required: true,
        value: values?.nominatorPhone,
      },
      {
        key: "uploadNominator",
        width: isMobileMode ? 12 : 7,
        label: "File công văn giới thiệu của đơn vị đề cử",
        render: renderUploadFile(
          <Typography
            className="kpt-textfield-label"
            style={{ display: "inline" }}
          >
            {`Upload file Công văn giới thiệu của đơn vị đề cử (Tải file mẫu `}
            <a
              href={GTNS2026_LINKS.mauCvDeCu}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: SECONDARY_COLOR }}
            >
              tại đây
            </a>
            {")"}
          </Typography>,
          "nominator"
        ),
        required: true,
        value: files?.nominator,
      },
      {
        key: "videoUrl",
        width: 12,
        label:
          "Link video giới thiệu bản thân và 05 ảnh về hoạt động cá nhân trong học tập, nghiên cứu và công tác",
        required: true,
        labelRender: (
          <Typography className="kpt-textfield-label">
            Link video giới thiệu bản thân và 05 ảnh về hoạt động cá nhân trong
            học tập, nghiên cứu và công tác
            <span style={{ color: theme.palette.secondary.main }}>*</span>:
            <i style={{ display: "block", fontSize: 13, fontWeight: 400, color: SECONDARY_COLOR }}>
              Lưu ý:
              <span style={{ display: "block" }}>
                + Video giới thiệu cá nhân không quá 02 phút, giới thiệu về cá
                nhân, các thành tích, công trình nghiên cứu khoa học hoặc giải
                pháp công nghệ tiêu biểu, giá trị khoa học, khả năng ứng dụng và
                tác động xã hội.
              </span>
              <span style={{ display: "block" }}>
                + 05 ảnh về hoạt động cá nhân trong học tập, nghiên cứu và công
                tác.
              </span>
              <span style={{ display: "block" }}>
                + Video, hình ảnh phải bảo đảm chất lượng, video âm thanh rõ,
                hình thức đẹp, chuyên nghiệp, dung lượng và định dạng phù hợp để
                Ban Tổ chức sử dụng, thiết kế các sản phẩm truyền thông trên các
                nền tảng số.
              </span>
              <span style={{ display: "block" }}>
                + Đề nghị đặt tên ảnh theo cấu trúc: Tên nữ sinh – Trường đại học
                – Mô tả ngắn gọn nội dung ảnh.
              </span>
              <span style={{ display: "block" }}>
                + Vui lòng kiểm tra và thiết lập quyền truy cập đối với link
                Google Drive trước khi gửi để đảm bảo Ban tổ chức có thể truy
                cập.
              </span>
            </i>
          </Typography>
        ),
      },
    ],
    partII: [
      {
        key: "politicalUnion",
        width: isMobileMode ? 12 : 6,
        label: "Đoàn thể chính trị",
        required: true,
        options: POLITICAL_UNION_OPTIONS,
      },
      {
        key: "languague",
        width: isMobileMode ? 12 : 6,
        label: "Ngoại ngữ",
        required: true,
      },
      {
        key: "gifted",
        width: 12,
        height: 2,
        label: "Năng khiếu",
        required: true,
      },
      {
        key: "university",
        width: 12,
        label: "Tên trường/học viện đang theo học",
        required: true,
      },
    ],
    partIII: [
      { key: "faculty", width: 12, label: "Tên Khoa/Viện", required: true },
      {
        key: "facultyPhone",
        width: 12,
        label: "Điện thoại liên hệ Đoàn trường/học viện",
        required: true,
      },
      {
        key: "studentYear",
        width: isMobileMode ? 12 : 4,
        label: "Sinh viên năm thứ",
        type: "int",
        min: 0,
        required: true,
      },
      {
        key: "major",
        width: isMobileMode ? 12 : 8,
        label: "Ngành học",
        required: true,
      },
      {
        key: "field",
        width: 12,
        label: "Nhóm ngành đăng ký",
        options: FORM_CONSTANTS.FIELD_OPTIONS[APP_SCENE],
        required: true,
        labelRender: (
          <Typography className="kpt-textfield-label">
            Nhóm ngành đăng ký
            <span style={{ color: theme.palette.secondary.main }}>*</span>:
            {GTNS2026_LINKS.phuLucNganh ? (
              <i style={{ display: "block", fontSize: 13, fontWeight: 400, color: SECONDARY_COLOR }}>
                Xem{" "}
                <a
                  href={GTNS2026_LINKS.phuLucNganh}
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: SECONDARY_COLOR, textDecoration: "underline" }}
                >
                  Phụ lục các ngành thuộc các nhóm ngành
                </a>{" "}
                để chọn đúng nhóm ngành.
              </i>
            ) : (
              <i style={{ display: "block", fontSize: 13, fontWeight: 400, color: SECONDARY_COLOR }}>
                Lưu ý chọn đúng nhóm ngành (xem Phụ lục các ngành thuộc các nhóm
                ngành).
              </i>
            )}
          </Typography>
        ),
      },
    ],
    // A. THÀNH TÍCH HỌC TẬP (NSKH 2026): chuyển Điểm TB chung + File bảng điểm
    // về mục riêng để bố trí theo thứ tự bảng điểm.
    academicAchievement: [
      {
        key: "gpa",
        width: 12,
        label: "1. Điểm TB chung học tập (quy đổi theo thang điểm 4)",
        type: "float",
        min: 0,
        step: 0.01,
        required: true,
      },
      {
        key: "uploadGpa",
        width: 12,
        label:
          "2. File Bảng điểm học tập (được xác nhận và đóng dấu của đơn vị đào tạo)",
        render: renderUploadFile(
          "2. File Bảng điểm học tập (được xác nhận và đóng dấu của đơn vị đào tạo)",
          "gpa"
        ),
        value: files?.gpa,
        required: true,
      },
    ],
  };

  const topPart = isMobileMode ? textForm.base.slice(0, 4) : textForm.base;
  const botPart = isMobileMode
    ? textForm.base.slice(4, textForm.base.length)
    : [];

  const achievementFields = [
    {
      index: "1",
      actions: ["link", "detail", "delete"],
      type: ACHIEVEMENT_TYPE.SOLUTION,
      title:
        "Có bằng độc quyền sáng chế, giải pháp hữu ích thuộc các nhóm ngành xét chọn",
      data: achievementData[ACHIEVEMENT_TYPE.SOLUTION]?.map((e) => ({
        ...e,
        issueAt: dayjs(e?.issueAt).format("DD/MM/YYYY"),
      })),
    },
    {
      index: "2",
      actions: ["link", "detail", "delete"],
      type: ACHIEVEMENT_TYPE.SOLUTION + CATEGORY.GTNS,
      title:
        "Có sáng chế/ giải pháp hữu ích đã được chấp nhận đơn hợp lệ thuộc các nhóm ngành xét chọn",
      data: achievementData[ACHIEVEMENT_TYPE.SOLUTION + CATEGORY.GTNS]?.map(
        (e) => ({ ...e, issueAt: dayjs(e?.issueAt).format("DD/MM/YYYY") })
      ),
    },
    {
      index: "3",
      title:
        "Bài báo khoa học đăng trên tạp chí quốc tế/quốc gia thuộc các nhóm ngành xét giải",
      note: "Ứng viên chỉ khai các tạp chí thuộc danh mục của Hội đồng chức danh GSNN",
      children: [
        {
          index: "3.1",
          actions: ["link", "detail", "delete"],
          type: ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.INTERNATIONAL,
          title: "Bài báo khoa học trên tạp chí uy tín quốc tế ",
          data: achievementData[
            ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.INTERNATIONAL
          ],
        },
        {
          index: "3.2",
          actions: ["link", "detail", "delete"],
          type: ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.DOMESTIC,
          title: "Bài báo khoa học đăng trên tạp chí trong nước",
          data: achievementData[
            ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.DOMESTIC
          ],
          defaultData: { type: "q6" },
        },
      ],
    },
    {
      index: "4",
      actions: ["link", "detail", "delete"],
      title:
        "Bài báo khoa học đăng toàn văn trên kỷ yếu hoặc poster được báo cáo tại hội nghị/hội thảo quốc tế/quốc gia thuộc các nhóm ngành xét giải",
      note: "Không xét với các bài đăng tóm tắt và poster trưng bày",
      type: ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT,
      data: achievementData[ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT],
    },
    {
      index: "5",
      title:
        "Tham gia đề tài nghiên cứu khoa học sinh viên thuộc các nhóm ngành xét giải tham gia báo cáo, dự thi",
      note: "Minh chứng là Bằng khen/Giấy khen đề tài",
      children: [
        {
          index: "5.1",
          actions: ["link", "detail", "delete"],
          type: ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHCB,
          title:
            "Đề tài nghiên cứu khoa học cấp Bộ và tương đương đã nghiệm thu",
          data: achievementData[ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHCB],
        },
        {
          index: "5.2",
          actions: ["link", "detail", "delete"],
          type: ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHCT,
          title:
            "Đề tài nghiên cứu khoa học cấp Trường và tương đương đã nghiệm thu",
          data: achievementData[ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHCT],
        },
      ],
    },
    {
      // NSKH 2026: mục mới (B.6) — gộp 6.1 và 6.2 thành 1 mục chung
      index: "6",
      actions: ["link", "detail", "delete"],
      type: ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHDA,
      title:
        "Tham gia đề tài, dự án nghiên cứu khoa học được Hội đồng khoa học có thẩm quyền nghiệm thu, xếp loại đạt yêu cầu trở lên",
      note: "Minh chứng là Biên bản nghiệm thu đề tài, Quyết định xếp loại",
      data: achievementData[ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHDA],
    },
    {
      index: "7",
      title:
        "Đạt Huy chương/Giải thưởng các cuộc thi học thuật thuộc các nhóm ngành xét giải",
      children: [
        {
          index: "7.1",
          actions: ["link", "detail", "delete"],
          type: ACHIEVEMENT_TYPE.REWARD + KEYS.HTQT,
          title: "Huy chương/Giải thưởng cấp quốc tế",
          data: achievementData[ACHIEVEMENT_TYPE.REWARD + KEYS.HTQT],
        },
        {
          index: "7.2",
          actions: ["link", "detail", "delete"],
          type: ACHIEVEMENT_TYPE.REWARD + KEYS.HTQG,
          title: "Huy chương/Giải thưởng cấp quốc gia",
          data: achievementData[ACHIEVEMENT_TYPE.REWARD + KEYS.HTQG],
        },
        {
          index: "7.3",
          actions: ["link", "detail", "delete"],
          type: ACHIEVEMENT_TYPE.REWARD + KEYS.HTCS,
          title: "Huy chương/Giải thưởng cấp Bộ, ban, ngành, tỉnh",
          data: achievementData[ACHIEVEMENT_TYPE.REWARD + KEYS.HTCS],
        },
      ],
    },
  ];
  // console.log("achievementData", achievementData);

  const activityFields = [
    {
      key: KEYS.REWARD,
      values: reward,
      setValues: setReward,
      label: isMobileMode
        ? "Thành tích khen thưởng"
        : "Thành tích khen thưởng (Bằng khen, Giấy khen... xếp thứ tự từ khen thưởng cao xuống thấp, không kê khai lại các thành tích trong lĩnh vực chuyên ngành )",
      fields: [
        {
          key: `${KEYS.REWARD}Content`,
          width: isMobileMode ? 12 : 4,
          label: "Nội dung khen thưởng",
          required: true,
        },
        {
          key: `${KEYS.REWARD}Type`,
          width: isMobileMode ? 12 : 3,
          label: "Cấp khen thưởng",
          options: FORM_CONSTANTS.REWARD_LEVEL_GTNS_OPTIONS,
          required: true,
        },
        {
          key: `${KEYS.REWARD}PreviewFile`,
          label: "Minh chứng",
          width: isMobileMode ? 12 : 4,
          type: "file",
          required: true,
        },
      ],
    },
    {
      key: KEYS.SOCIAL_ACTIVITY,
      values: socialActivity,
      setValues: setSocialActivity,
      label: "Thành tích hoạt động Đoàn, Hội, Đội",
      fields: [
        {
          key: `${KEYS.SOCIAL_ACTIVITY}Content`,
          width: isMobileMode ? 12 : 7,
          label: "Hình thức và nội dung thành tích",
          required: true,
        },
        {
          key: `${KEYS.SOCIAL_ACTIVITY}PreviewFile`,
          width: isMobileMode ? 12 : 4,
          label: "Minh chứng",
          type: "file",
          required: true,
        },
      ],
    },
  ];

  const newFileLength = useMemo(() => {
    const len = {
      [KEYS.SOCIAL_ACTIVITY]: 0,
      [KEYS.PERSONAL_PROCESS]: 0,
      [KEYS.OTHER_ACHIEVEMENT]: 0,
    };
    Object.keys(files).forEach((key) => {
      if (key.includes(KEYS.SOCIAL_ACTIVITY))
        len[KEYS.SOCIAL_ACTIVITY] = len[KEYS.SOCIAL_ACTIVITY] + files[key].size;
      if (key.includes(KEYS.PERSONAL_PROCESS))
        len[KEYS.PERSONAL_PROCESS] =
          len[KEYS.PERSONAL_PROCESS] + files[key].size;
      if (key.includes(KEYS.OTHER_ACHIEVEMENT))
        len[KEYS.OTHER_ACHIEVEMENT] =
          len[KEYS.OTHER_ACHIEVEMENT] + files[key].size;
    });
    return len;
  }, [files]);

  const handleChangeActivityForm = (name, event, type, values, setValues) => {
    const keyList = name.split(".");
    const key = keyList[2];
    const index = parseInt(keyList[1]);

    const tmp = [...values];
    if (type === "date") {
      tmp.splice(index, 1, { ...tmp[index], [key]: event });
    } else if (type === "removeFile") {
      tmp.splice(index, 1, { ...tmp[index], [key]: undefined });
    } else {
      tmp.splice(index, 1, { ...tmp[index], [key]: event.target.value });
    }
    setValues(tmp);
  };

  const handleReload = (profileId) => {
    dispatch(formActions.getApplicationFormv2(profileId));
    dispatch(
      formActions.filterApplicationForm({
        category: APP_SCENE,
        seasonId: openSeasonId,
        profileId: profile.id,
      })
    ).then((applications) => {
      if (applications.length > 0) {
        const application = applications[0];

        if (application.reward === "") application.reward = "[]";
        if (application.previewFile === "") application.previewFile = "[]";
        if (application.socialActivity === "")
          application.socialActivity = "[]";
        if (application.majorAchievement === "")
          application.majorAchievement = "[]";

        const fileList = JSON.parse(application.previewFile);
        application.uploadGpa = fileList?.find((file) => file?.includes("gpa"));
        application.uploadNominator = fileList?.find((file) =>
          file?.includes("nominator")
        );
        application.uploadCurriculum = fileList?.find((file) =>
          file?.includes("curriculum")
        );
        application.uploadFiveSocialActivity = fileList
          ?.filter((file) => file?.includes("fiveSocialActivity"))
          .map((file) => photoRender(file));
        // NSKH 2026: file Kê khai thành tích có xác nhận đóng dấu nhà trường
        application.uploadConfirmation = fileList?.find((file) =>
          file?.includes("confirmation")
        );
        // F. Cam kết: file Bản cam kết của ứng viên
        application.uploadCamKet = fileList?.find((file) =>
          file?.includes("camKet")
        );

        if (application) {
          setValues({ ...values, ...application });
          setReward(JSON.parse(application.reward) || []);
          setSocialActivity(JSON.parse(application.socialActivity) || []);
          setMajorAchievement(JSON.parse(application.majorAchievement) || []);
          // E. Ưu tiên (JSON)
          try {
            setPriority(JSON.parse(application.priority) || {});
          } catch (e) {
            setPriority({});
          }
        }
      }
    });
  };

  const upsertApplication = (status, uploadedFiles = []) => {
    const parseJsonActivity = (key) => {
      let dataSource = [];
      if (key === KEYS.REWARD) dataSource = [...reward];
      else if (key === KEYS.SOCIAL_ACTIVITY) dataSource = [...socialActivity];
      else if (key === KEYS.MAJOR_ACHIEVEMENT)
        dataSource = [...majorAchievement];

      dataSource = dataSource
        .filter((data) => Object.values(data).length !== 0)
        .map((data, index) => ({
          ...data,
          [`${key}PreviewFile`]:
            uploadedFiles.find((file) => {
              const keys = file
                .split(`/storage/awardRegister/profile/${profile?.id}/`)[1]
                .split(".");
              return keys[0] === key && parseInt(keys[1]) === index;
            }) ||
            data?.[`${key}PreviewFile`] ||
            "",
        }));

      return dataSource ? JSON.stringify(dataSource) : "";
    };

    const achivementFormData = {};
    [
      ACHIEVEMENT_TYPE.REWARD,
      ACHIEVEMENT_TYPE.SOLUTION,
      ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT,
      ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH,
    ].forEach((key) => {
      if (key === ACHIEVEMENT_TYPE.SOLUTION) {
        achivementFormData["form" + capitalizeFirstLetter(key)] =
          achievementData[key + CATEGORY.GTNS].map((e) => ({
            [key + "Id"]: e.id,
          }));
        return;
      }
      achivementFormData["form" + capitalizeFirstLetter(key)] = achievementData[
        key
      ].map((e) => ({ [key + "Id"]: e.id }));
    });

    const gpa =
      uploadedFiles?.find((file) => file.includes("gpa")) || values?.uploadGpa;
    const nominator =
      uploadedFiles?.find((file) => file.includes("nominator")) ||
      values?.uploadNominator;
    const sumaryFiles = uploadedFiles?.filter((file) =>
      file.includes("fiveSocialActivity")
    );
    // NSKH 2026: file Kê khai thành tích có xác nhận đóng dấu nhà trường
    const confirmation =
      uploadedFiles?.find((file) => file.includes("confirmation")) ||
      values?.uploadConfirmation;
    // F. Cam kết
    const camKet =
      uploadedFiles?.find((file) => file.includes("camKet")) ||
      values?.uploadCamKet;

    const previewFile = [
      ...sumaryFiles,
      gpa,
      nominator,
      confirmation,
      camKet,
    ].filter(Boolean);

    const payload = {
      ...values,
      ...achivementFormData,
      status,
      seasonId: openSeasonId,
      category: APP_SCENE,
      profileId: profile.id,
      previewFile: JSON.stringify(previewFile),
      // E. Ưu tiên
      priority: JSON.stringify(priority),

      [KEYS.REWARD]: parseJsonActivity(KEYS.REWARD),
      [KEYS.SOCIAL_ACTIVITY]: parseJsonActivity(KEYS.SOCIAL_ACTIVITY),
      [KEYS.MAJOR_ACHIEVEMENT]: parseJsonActivity(KEYS.MAJOR_ACHIEVEMENT),
    };

    // Thông báo theo trạng thái: nộp hồ sơ (in_review) vs lưu nháp/tải file (unsubmit)
    const successMsg =
      status === "in_review"
        ? "Nộp hồ sơ thành công,  thông tin chi tiết đã gửi đến email của bạn. Nếu không nhận được email trong vài phút, vui lòng kiểm tra thư mục Spam hoặc liên hệ với chúng tôi."
        : "Đã lưu bản nháp thành công.";

    // Hồ sơ rỗng thì tạo hồ sơ mới, không thì cập nhật đè lên hồ sơ cũ
    if (!application) {
      dispatch(formActions.insertApplicationForm(payload)).then((success) => {
        if (success) {
          dispatch(
            userActions.notification({
              message: successMsg,
              type: "success",
            })
          );
          // window.location.reload();
        }
      });
    } else {
      dispatch(formActions.updateApplicationForm(payload)).then((success) => {
        if (success) {
          dispatch(
            userActions.notification({
              message: successMsg,
              type: "success",
            })
          );
        }
      });
    }
  };

  const handleSave = (status) => {
    const formFields = [
      ...textForm.partI,
      ...textForm.partII,
      ...textForm.partIII,
      ...textForm.academicAchievement,
    ];

    for (const elm of formFields) {
      if (status === "unsubmit") continue;

      const value = elm?.value || values?.[elm.key];

      if (!elm.disabled && elm.required && !value) {
        setValues({ ...values, emptyKey: elm.key });
        jumpToReleventDiv(elm.key);
        dispatch(
          userActions.notification({
            message: `Không được để trống thông tin về: ${
              elm?.renderLabel || elm?.label
            }`,
            type: "error",
          })
        );
        return;
      }
    }

    for (const active of activityFields) {
      if (status === "unsubmit") continue;

      for (const field of active.fields) {
        if (field.required) {
          let key = field.key;
          for (var i = 0; i < active.values.length; i++) {
            const value = active.values[i];
            if (
              (!value[key] || value[key] == "[]") &&
              !files?.[`${active.key}.${i}.${key}`]
            ) {
              setEmptyKey(key);
              dispatch(
                userActions.notification({
                  message: `Không được để trống thông tin về: ${field.label}`,
                  type: "error",
                })
              );
              return;
            }
          }
        }
      }
    }

    if (!profile?.id) {
      dispatch(
        userActions.notification({
          message: "Lỗi profile ID, vui lòng tải lại trang!",
          type: "error",
        })
      );
      return false;
    }

    const uploadFiles = { ...files };
    values.uploadFiveSocialActivity?.forEach(
      (value, index) => (uploadFiles[`fiveSocialActivity.${index}`] = value)
    );

    if (Object.keys(uploadFiles).length > 0) {
      setUploadingFiles(true);
      dispatch(fileActions.importMultiFileQCV(profile.id, uploadFiles)).then(
        (uploadedFiles) => {
          setUploadingFiles(false);
          if (!uploadedFiles) {
            dispatch(
              userActions.notification({
                message: "Lỗi upload files, vui lòng tải lại trang!",
                type: "error",
              })
            );
            return;
          }
          upsertApplication(status, uploadedFiles);
        }
      );
    } else {
      upsertApplication(status);
    }

    return true;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    handleSave("in_review");
  };

  // Trích xuất file Kê khai thành tích để in/ký/đóng dấu (giống QCV).
  // Lưu nháp trước để giữ dữ liệu, rồi xuất từ dữ liệu đang có trên giao diện.
  const handleExportProfile = () => {
    handleSave("unsubmit");
    exportGtnsProfile({
      profile,
      values,
      achievementData,
      reward,
      socialActivity,
      priority,
    });
  };

  const openSeason = useMemo(
    () => seasonList.find((s) => s.id === openSeasonId),
    [seasonList, openSeasonId]
  );

  const isNotAvalaible = useMemo(() => {
    if (!openSeason) return false;
    const { openDate, closeDate } = openSeason;
    const currDate = new Date();
    if (currDate < new Date(openDate)) return "Chưa mở cổng đăng ký";
    if (currDate > new Date(closeDate)) return "Đã hết thời hạn đăng ký";
    return null;
  }, [openSeason]);

  // Vừa vào trang thì lấy thông tin hồ sơ luôn
  useEffect(() => {
    if (openSeasonId && profile?.id) handleReload(profile?.id);
  }, [openSeasonId, profile]);

  useEffect(() => {
    if (values?.uploadFiveSocialActivity)
      handleFileChange(values?.uploadFiveSocialActivity, "fiveSocialActivity");
  }, [values?.uploadFiveSocialActivity]);

  // if (!values) return null;

  // console.log(values);

  const disabledChange = useMemo(() => {
    if (values?.status === "in_review") return true;
    // if (isNotAvalaible) return true;
    return false;
  }, [values?.status]);

  // Render 1 mục InputActives theo key (dùng cho bố cục nhóm B/C/D)
  const renderActivity = (key) => {
    const active = activityFields.find((a) => a.key === key);
    if (!active) return null;
    return (
      <Card style={{ width: "100%", marginTop: 32 }}>
        <InputActives
          id={active.key}
          {...active}
          newFileLength={newFileLength[active.key]}
          setPreview={setPreviewFile}
          handleFileChange={handleFileChange}
          handleChangeForm={handleChangeActivityForm}
        />
      </Card>
    );
  };

  // Header tiêu đề nhóm (A/B/C/D/E)
  const sectionHeader = (text, note) => (
    <Card style={{ width: "100%", marginTop: 96 }}>
      <Box height={6} bgcolor="#233871" />
      <Box padding={2}>
        <Typography variant="h5" style={{ textAlign: "left" }}>
          <b>{text}</b>
        </Typography>
        {note && (
          <Typography variant="subtitle1" style={{ marginTop: 4, color: SECONDARY_COLOR }}>
            <i>
              <b>Lưu ý: </b>
              {note}
            </i>
          </Typography>
        )}
      </Box>
    </Card>
  );

  return (
    <>
      <Card style={{ width: "100%", marginTop: 64 }}>
        <Box height={6} bgcolor="#233871" />
        <Box padding={2}>
          <Typography
            variant="h4"
            style={{ textAlign: "center", textTransform: "uppercase" }}
          >
            <b>Đăng ký hồ sơ</b>
          </Typography>
        </Box>
      </Card>

      <Card
        style={{
          width: "100%",
          marginTop: 32,
          display: showCSKH ? "block" : "none",
        }}
      >
        <CardHeader
          style={{ paddingRight: 4, paddingTop: 2, paddingBottom: 2 }}
          title={
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h6">
                <b>
                  Hỗ trợ đăng ký Giải thưởng Nữ sinh khoa học công nghệ Việt Nam
                </b>
              </Typography>
              <IconButton onClick={() => setShowCSKH(false)}>
                <Close />
              </IconButton>
            </Box>
          }
        />
        <Divider />
        <CardContent style={{ paddingTop: 2, paddingBottom: 2 }}>
          <ul>
            <li>
              Hỗ trợ nội dung giải thưởng: Ms Linh (
              <a href="tel:0918023066">0918.023.066</a>)
            </li>
            <li style={{ marginTop: 4 }}>
              Hỗ trợ kỹ thuật hệ thống: Ms Trang (
              <a href="http://zalo.me/0339028002">0339.028.002</a>)
            </li>
          </ul>
        </CardContent>
      </Card>

      <form
        className="dkhs-container"
        id="form-update"
        defaultValue={values}
        onSubmit={handleSubmit}
      >
        <Card style={{ width: "100%" }}>
          <CardContent>
            <Box display="flex">
              <Box flexGrow={1} marginTop="4px">
                <KPTextform component="div" textForm={topPart} />
              </Box>
              <Box marginTop="4px" marginLeft={1}>
                <Typography className="kpt-textfield-label">
                  {isMobileMode ? "Ảnh chân dung" : "Ảnh chân dung (4x6)"}
                  <span style={{ color: theme.palette.secondary.main }}>*</span>
                  {":"}
                </Typography>
                <Box>
                  <Card className="dkhs-photoContainer">
                    <img
                      alt="anh-chan-dung"
                      className="dkhs-photo"
                      src={photoRender(profile?.photoUrl)}
                    />
                  </Card>
                </Box>
              </Box>
            </Box>
            <Box flexGrow={1} marginTop="4px">
              <KPTextform component="div" textForm={botPart} />
            </Box>
          </CardContent>
        </Card>

        <Card style={{ width: "100%", marginTop: 32 }}>
          <CardContent>
            <KPTextform
              component={Box}
              textForm={textForm.partI}
              values={values}
              setValues={setValues}
              handleSubmit={handleSubmit}
            />
          </CardContent>
        </Card>

        <Card style={{ width: "100%", marginTop: 32 }}>
          <CardContent>
            <KPTextform
              component={Box}
              textForm={textForm.partII}
              values={values}
              setValues={setValues}
              handleSubmit={handleSubmit}
            />
          </CardContent>
        </Card>

        <Card style={{ width: "100%", marginTop: 32 }}>
          <CardContent>
            <KPTextform
              component={Box}
              textForm={textForm.partIII}
              values={values}
              setValues={setValues}
              handleSubmit={handleSubmit}
            />
          </CardContent>
        </Card>

        {/* A. THÀNH TÍCH HỌC TẬP */}
        <Card style={{ width: "100%", marginTop: 96 }}>
          <Box height={6} bgcolor="#233871" />
          <Box padding={2}>
            <Typography variant="h5" style={{ textAlign: "left" }}>
              <b>A. Thành tích học tập</b>
            </Typography>
          </Box>
        </Card>
        <Card style={{ width: "100%", marginTop: 32 }}>
          <CardContent>
            <Typography variant="subtitle1" style={{ marginBottom: 12, color: SECONDARY_COLOR }}>
              <i>
                <b>Lưu ý: </b>Công văn giới thiệu, bảng điểm, bằng khen, giấy
                khen, giấy chứng nhận hay các văn bản có liên quan làm minh chứng
                phải được scan bản gốc hoặc có chữ ký, đóng dấu đỏ của đơn vị chủ
                quản.
              </i>
            </Typography>
            <KPTextform
              component={Box}
              textForm={textForm.academicAchievement}
              values={values}
              setValues={setValues}
              handleSubmit={handleSubmit}
            />
          </CardContent>
        </Card>

        {/* B. THÀNH TÍCH KHOA HỌC CÔNG NGHỆ */}
        <Card style={{ width: "100%", marginTop: 96 }}>
          <Box height={6} bgcolor="#233871" />
          <Box padding={2}>
            <Typography variant="h5" style={{ textAlign: "left" }}>
              <b>B. Thành tích Khoa học công nghệ</b>
            </Typography>
            <Typography variant="subtitle1" style={{ marginTop: 4, color: SECONDARY_COLOR }}>
              <i>
                <b>Lưu ý: </b>chỉ khai các thành tích đạt được trong quá trình
                học đại học.
              </i>
            </Typography>
          </Box>
        </Card>

        {achievementFields.map((e) => (
          <Card key={e?.index} style={{ width: "100%", marginTop: 32 }}>
            <Box
              padding={e.type ? "2px 4px 2px 16px" : "8px 16px"}
              display="flex"
              alignItems="center"
            >
              <Typography variant="h6" style={{ flexGrow: 1 }}>
                <b>{`${e?.index}. ${e?.title}`}</b>
                {e?.note && (
                  <i
                    style={{ display: "block", fontSize: 13, fontWeight: 400, color: SECONDARY_COLOR }}
                  >
                    Lưu ý: {e.note}
                  </i>
                )}
              </Typography>
              {e.type && (
                <>
                  <Tooltip arrow title={<ThanhTichAlert closable={false} />}>
                    <Info style={{ cursor: "pointer" }} />
                  </Tooltip>
                  <IconButton
                    color="primary"
                    onClick={() =>
                      setDialog({ type: e?.type, title: e?.title })
                    }
                  >
                    <Add />
                  </IconButton>
                </>
              )}
            </Box>
            {e.type ? (
              <>
                <Divider />
                <KPTable
                  nonBorder={true}
                  columns={columnRender(e, setDialog, setPreviewFile)}
                  rows={e.data || []}
                />
              </>
            ) : (
              <>
                {e.children.map((item) => (
                  <>
                    <Divider />
                    <Box
                      padding="2px 4px 2px 16px"
                      display="flex"
                      alignItems="center"
                    >
                      <Typography variant="h6" style={{ flexGrow: 1 }}>
                        <b>{`${item?.index}. ${item?.title}`}</b>
                        {item?.note && (
                          <i
                            style={{
                              display: "block",
                              fontSize: 13,
                              fontWeight: 400,
                              color: SECONDARY_COLOR,
                            }}
                          >
                            Lưu ý: {item.note}
                          </i>
                        )}
                      </Typography>
                      <Tooltip
                        arrow
                        title={<ThanhTichAlert closable={false} />}
                      >
                        <Info style={{ cursor: "pointer" }} />
                      </Tooltip>
                      <IconButton
                        color="primary"
                        onClick={() =>
                          setDialog({
                            type: item?.type,
                            title: item?.title,
                            data: item?.defaultData,
                          })
                        }
                      >
                        <Add />
                      </IconButton>
                    </Box>
                    <Divider />
                    <KPTable
                      nonBorder={true}
                      columns={columnRender(item, setDialog, setPreviewFile)}
                      rows={item.data || []}
                    />
                  </>
                ))}
              </>
            )}
          </Card>
        ))}

        {/* C. KHEN THƯỞNG THÀNH TÍCH KHCN */}
        {sectionHeader(
          "C. Khen thưởng thành tích KHCN",
          "Thành tích khen thưởng (Bằng khen, Giấy khen...) xếp thứ tự từ khen thưởng cao xuống thấp, không kê khai lại các thành tích trong lĩnh vực chuyên ngành."
        )}
        {renderActivity(KEYS.REWARD)}

        {/* D. THÀNH TÍCH HOẠT ĐỘNG ĐOÀN, HỘI */}
        {sectionHeader("D. Thành tích hoạt động Đoàn, Hội")}
        {renderActivity(KEYS.SOCIAL_ACTIVITY)}

        {/* E. ƯU TIÊN */}
        {sectionHeader("E. Ưu tiên")}
        <Card style={{ width: "100%", marginTop: 32 }}>
          <CardContent>
            <Grid container spacing={1}>
              {GTNS2026_PRIORITY_FIELDS.map((f) => (
                <Grid item xs={12} md={6} key={f.key}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={!!priority?.[f.key]}
                        onChange={(e) =>
                          setPriority({ ...priority, [f.key]: e.target.checked })
                        }
                      />
                    }
                    label={f.label}
                  />
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>

        {/* F. CAM KẾT */}
        {sectionHeader("F. Cam kết")}
        <Card style={{ width: "100%", marginTop: 32 }}>
          <CardContent>
            <Typography variant="body1" style={{ marginBottom: 12 }}>
              Ứng viên tải mẫu Bản cam kết
              {GTNS2026_LINKS.mauCamKet ? (
                <>
                  {" "}
                  <a
                    href={GTNS2026_LINKS.mauCamKet}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      textDecoration: "underline",
                      color: SECONDARY_COLOR,
                    }}
                  >
                    tại đây
                  </a>
                </>
              ) : null}
              , điền đầy đủ nội dung, ký và upload lại file Bản cam kết đã hoàn
              thiện.
            </Typography>
            {renderUploadFile("File Bản cam kết của ứng viên", "camKet")}
          </CardContent>
        </Card>

        {/* Mục tải file xin xác nhận (wording giống GT QCV) */}
        <Card style={{ width: "100%", marginTop: 32 }}>
          <CardContent>
            <Typography variant="body1" style={{ fontSize: 17 }}>
              <b>Tải file xin xác nhận</b>
            </Typography>
            <Typography variant="body1" style={{ marginBottom: 12 }}>
              Trước khi ấn nộp hồ sơ, tải file Kê khai thành tích cá nhân (trích
              xuất{" "}
              <a
                onClick={(event) => {
                  event.preventDefault();
                  handleExportProfile();
                }}
                href="#"
                style={{ textDecoration: "underline", color: SECONDARY_COLOR }}
              >
                tại đây
              </a>
              ), xin xác nhận đóng dấu của thủ trưởng cơ quan, đơn vị quản lý
              trực tiếp (lãnh đạo nhà trường) và upload file đã xin xác nhận
              trước khi nộp.
            </Typography>
            {renderUploadFile(
              "File Kê khai thành tích cá nhân đã có xác nhận, đóng dấu",
              "confirmation"
            )}
          </CardContent>
        </Card>

        <Card style={{ width: "100%", padding: 16, marginTop: 32 }}>
          <Grid container spacing={2} justifyContent="center">
            {disabledChange ? (
              <Grid item xs={12}>
                <Typography variant="subtitle1" color="error">
                  <b>Hồ sơ đã được nộp, không thể chỉnh sửa!</b>
                </Typography>
              </Grid>
            ) : (
              <>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="secondary"
                        checked={acceptRules}
                        onChange={() => setAcceptRules(!acceptRules)}
                      />
                    }
                    label={
                      <Typography variant="subtitle1">
                        <b style={{ fontFamily: "SFProDisplay" }}>
                          Tôi xin hoàn toàn chịu trách nhiệm trước pháp luật,
                          Ban tổ chức Giải thưởng về tính chính xác và các thông
                          tin đã khai trong hồ sơ đăng ký trực tuyến tham gia
                          xét giải thưởng
                        </b>
                      </Typography>
                    }
                    style={{ marginTop: 48 }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    disabled={!acceptRules}
                    variant="outlined"
                    onClick={() => handleSave("unsubmit")}
                  >
                    Lưu bản nháp
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  {/* <Button
                fullWidth
                disabled={!acceptRules}
                form="form-update"
                type="submit"
                color="secondary"
                variant="contained"
              >
                Nộp hồ sơ
              </Button> */}
                  <ConfirmButton
                    onConfirm={(e) => {
                      // Gọi API, dispatch Redux, reload page, v.v.
                      // console.log("Confirmed");
                      handleSubmit(e);
                    }}
                    disabled={!acceptRules}
                    buttonText="Nộp hồ sơ"
                    confirmText="Lưu ý: Sau khi ứng viên nhấn 'Nộp hồ sơ', hệ thống sẽ khóa hồ sơ và không cho phép chỉnh sửa hoặc bổ sung thông tin, thành tích. Do đó, ứng viên vui lòng kiểm tra kỹ toàn bộ nội dung hồ sơ (bao gồm thông tin cá nhân, minh chứng, thành tích…) trước khi nộp để tránh sai sót và đảm bảo hồ sơ đầy đủ, chính xác."
                    confirmButtonLabel="Đồng ý"
                    cancelButtonLabel="Hủy"
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Card>
      </form>

      <ThanhTichInsert dialog={dialog} setDialog={setDialog} />

      <Loading open={loading} />
      <PreviewModal
        open={!!previewFile}
        url={previewFile}
        handleClose={() => setPreviewFile(null)}
      />

      <Dialog
        fullWidth
        maxWidth="xs"
        open={!loading && (isNotAvalaible || warningOpen)}
      >
        <DialogTitle style={{ padding: "4px 12px 4px 24px" }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h5">
              <b>Thông báo</b>
            </Typography>
            {!isNotAvalaible && (
              // Chưa đóng cổng thì có thể tắt
              <IconButton onClick={() => setWarningOpen(false)}>
                <Close />
              </IconButton>
            )}
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box display="flex" width="100%" marginBottom={4}>
            <WarningRounded
              style={{ margin: "auto", color: "#4da6ff", fontSize: 72 }}
            />
          </Box>
          <Typography variant="h6" style={{ textAlign: "center" }}>
            {isNotAvalaible ? (
              <>
                {isNotAvalaible}
                <br />
                <b>Giải thưởng Nữ sinh KHCN năm {openSeason?.year}</b>
              </>
            ) : (
              <b>
                {application?.status === "in_review" &&
                  "Hồ sơ đã được nộp trên hệ thống!"}
              </b>
            )}
          </Typography>
        </DialogContent>
        <DialogActions style={{ padding: "8px 24px" }}>
          {isNotAvalaible ? (
            <Button
              fullWidth
              color="secondary"
              variant="contained"
              href={ROUTER.HOME}
            >
              Về trang chủ
            </Button>
          ) : (
            <>
              {application?.status === "in_review" && (
                <Grid container spacing={2} justifyContent="center">
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      href={ROUTER.QCV.HOME}
                      variant="outlined"
                      startIcon={<Home />}
                      onClick={() => setWarningOpen(false)}
                    >
                      Trang chủ
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      color="secondary"
                      variant="contained"
                      startIcon={<Edit />}
                      style={{ float: "right" }}
                      onClick={() => setWarningOpen(false)}
                    >
                      Chỉnh sửa hồ sơ
                    </Button>
                  </Grid>
                </Grid>
              )}
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}
